var _path, _path2, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAchievement = function SvgAchievement(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 138,
    viewBox: "0 0 130 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0721 1.83733C62.4177 -0.0942124 66.5395 -0.0942133 69.885 1.83733L119.94 30.7364C123.285 32.668 125.346 36.2376 125.346 40.1007V97.8989C125.346 101.762 123.285 105.332 119.94 107.263L69.885 136.162C66.5395 138.094 62.4177 138.094 59.0721 136.162L9.01741 107.263C5.67189 105.332 3.61096 101.762 3.61096 97.8989V40.1007C3.61096 36.2376 5.67189 32.668 9.01741 30.7364L59.0721 1.83733Z",
    fill: "#EB0029"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7645 5.37241C62.9339 3.54253 66.8388 3.54253 70.0083 5.37241L117.429 32.7505C120.598 34.5804 122.55 37.9621 122.55 41.6219V96.3781C122.55 100.038 120.598 103.42 117.429 105.249L70.0083 132.628C66.8388 134.457 62.9339 134.457 59.7645 132.628L12.3442 105.249C9.17475 103.42 7.22229 100.038 7.22229 96.3781V41.6219C7.22229 37.9621 9.17475 34.5804 12.3442 32.7505L59.7645 5.37241Z",
    fill: "#970012",
    fillOpacity: 0.99
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 116,
    height: 130
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7645 5.37241C62.9339 3.54253 66.8388 3.54253 70.0083 5.37241L117.429 32.7505C120.598 34.5804 122.55 37.9621 122.55 41.6219V96.3781C122.55 100.038 120.598 103.42 117.429 105.249L70.0083 132.628C66.8388 134.457 62.9339 134.457 59.7645 132.628L12.3442 105.249C9.17475 103.42 7.22229 100.038 7.22229 96.3781V41.6219C7.22229 37.9621 9.17475 34.5804 12.3442 32.7505L59.7645 5.37241Z",
    fill: "#8BBCE7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4117 71.2463L15.4674 73.7692L16.4117 68.4257L12.4117 64.6413L17.9396 63.8617L20.4117 59L22.8838 63.8617L28.4117 64.6413L24.4117 68.4257L25.356 73.7692L20.4117 71.2463Z",
    fill: "#FFD12E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4117 26.2463L60.4674 28.7692L61.4117 23.4257L57.4117 19.6413L62.9396 18.8617L65.4117 14L67.8838 18.8617L73.4117 19.6413L69.4117 23.4257L70.356 28.7692L65.4117 26.2463Z",
    fill: "#FFD12E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.412 71.2463L105.467 73.7692L106.412 68.4257L102.412 64.6413L107.94 63.8617L110.412 59L112.884 63.8617L118.412 64.6413L114.412 68.4257L115.356 73.7692L110.412 71.2463Z",
    fill: "#FFD12E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.783 61.9355L73.5584 77.3944L52.7006 113.521C52.3031 114.21 51.3001 114.181 50.9418 113.472L43.9723 99.6646L26.7321 99.6646C25.9623 99.6646 25.4812 98.8313 25.8661 98.1646L46.783 61.9355Z",
    fill: "#EE7984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.804 69.3164L66.9259 79.7791L52.183 105.315L46.9016 94.8519L34.061 94.8519L48.804 69.3164Z",
    fill: "#CA0F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9022 77.3945L82.6777 61.9357L103.536 98.0625C103.933 98.751 103.407 99.6056 102.613 99.561L87.1712 98.6932L78.5511 113.624C78.1662 114.29 77.204 114.29 76.8191 113.624L55.9022 77.3945Z",
    fill: "#EE7984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1882 79.7793L81.3102 69.3166L96.0531 94.8521L84.3514 94.1945L77.9311 105.315L63.1882 79.7793Z",
    fill: "#CA0F33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 66,
    rx: 28,
    ry: 28,
    fill: "#FFD12E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5398,
    cy: 66,
    rx: 22,
    ry: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2088 72.9003L57.1744 77L58.7088 68.3167L52.2088 62.1672L61.1916 60.9003L65.2088 53L69.226 60.9003L78.2088 62.1672L71.7088 68.3167L73.2432 77L65.2088 72.9003Z",
    fill: "#FFD12E"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAchievement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "achievement.847ce583b459e22b605ed3618254468e.svg";